export const navTrafficSafetyMenu = [
  [
    {
      key: 'traffic-safety:1',
      url: 'https://carolinas.aaa.com/traffic-safety/',
      label: 'AAA Traffic Safety',
    },
    {
      key: 'traffic-safety:2',
      url: 'https://carolinas.aaa.com/traffic-safety/advocacy/',
      label: 'Advocacy',
    },
    {
      key: 'traffic-safety:3',
      url: 'https://carolinas.aaa.com/traffic-safety/driving-classes/',
      label: 'Driving & Safety Classes',
    },
    {
      key: 'traffic-safety:4',
      url: 'https://carolinas.aaa.com/traffic-safety/driving-schools-nc/',
      label: 'NC Driving Schools',
    },
    {
      key: 'traffic-safety:5',
      url: 'https://carolinas.aaa.com/traffic-safety/driving-schools-sc/',
      label: 'SC Driving Schools',
    },
    {
      key: 'traffic-safety:6',
      url: 'https://carolinas.aaa.com/traffic-safety/safe-driving-resources/',
      label: 'Safe Driving Resources',
    },
  ],
  [
    {
      key: 'traffic-safety:7',
      url: 'https://carolinas.aaa.com/traffic-safety/kids/',
      label: 'AAA For Kids',
    },
    {
      key: 'traffic-safety:8',
      url: 'https://carolinas.aaa.com/traffic-safety/teens/',
      label: 'AAA For Teens',
    },
    {
      key: 'traffic-safety:9',
      url: 'https://carolinas.aaa.com/traffic-safety/adults/',
      label: 'AAA For Adults',
    },
    {
      key: 'traffic-safety:10',
      url: 'https://carolinas.aaa.com/traffic-safety/seniors/',
      label: 'AAA For Seniors',
    },
    {
      key: 'traffic-safety:11',
      url: 'https://carolinas.aaa.com/traffic-safety/videos-studies/',
      label: 'Videos & Studies',
    },
    {
      key: 'traffic-safety:12',
      url: 'https://carolinas.aaa.com/traffic-safety/newsletter/',
      label: 'Newsletter',
    },
    {
      key: 'traffic-safety:13',
      url: 'https://www.acgfoundation.org/',
      label: 'ACG Foundation',
    },
  ],
];

export const navTrafficSafetyPromo = [
  {
    title: 'Traffic Safety',
    content: 'AAA Members save 10% on all Traffic Safety classes.',
    img: '',
    buttonText: 'Register Here',
    buttonUrl: 'https://carolinas.aaa.com/traffic-safety/driving-classes/',
  },
];
